module.exports = __webpack_public_path__ + "static/media/icon-xitong.5c2f99f2.svg";